import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { RxCross2 } from "react-icons/rx";
import { updateAirdropReadStatusAction } from "../../Action/user.action";
import toast from "react-hot-toast";

const AirdropDoneModal = ({ show, handleClose, data = 0 }) => {
    const navigate = useNavigate();

    const handleOkClick = async () => {
        try {
            const res = await updateAirdropReadStatusAction();
            if (res?.success) {
                if (res.data[0].read_status) {
                    handleClose();
                }

            } else {
                console.warn("Failed to update read status:", res);
            }
        } catch (error) {
            console.error("Error updating read status:", error);
        }
    };
    return (
        <Modal
            show={show}
            onHide={handleClose}
            centered
            contentClassName="border-0 p-0 rounded-4 shadow-lg overflow-hidden"
        >
            <div
                style={{
                    background:
                        "linear-gradient(133deg, #41d3ffa5 0%, #7e42ffa0 47.4%, #dc3fffaf 96.19%)",
                    color: "#fff",
                    padding: "2rem 1rem",
                    textAlign: "center",
                    position: "relative",
                }}
            >

                <h2 className="fw-bold mb-2">🎉 Congratulations! 🎉</h2>
                <p className="fs-6 mb-0">
                    You have successfully received <strong>{data[0]?.airdrop_amount}</strong> ANANT in your external wallet via airdrop.
                </p>
            </div>

            <Modal.Body className="text-center text-dark p-4">
                <p className="fs-6 mb-3">

                    Please check the transaction details in your Stepmint Coin Wallet withdrawal history.
                </p>

                <Button
                    variant="secondary"
                    className="w-50 py-2 fw-semibold text-white border-0"
                    style={{
                        borderRadius: "12px",
                        background:
                            "linear-gradient(133deg, #41d3ffa5 0%, #7e42ffa0 47.4%, #dc3fffaf 96.19%)",
                        color: "#fff", transition: "transform 0.2s ease, box-shadow 0.2s ease",
                    }}
                    onMouseEnter={(e) =>
                        (e.currentTarget.style.transform = "scale(1.03)")
                    }
                    onMouseLeave={(e) =>
                        (e.currentTarget.style.transform = "scale(1)")
                    }
                    onClick={handleOkClick}
                >
                    OK
                </Button>

                <p style={{ fontSize: '10px' }} className="mt-3">
                    Click OK if you don’t want to see this message again.
                </p>

            </Modal.Body>
        </Modal>
    );
};

export default AirdropDoneModal;
